import { useState } from "react";
import { motion, useMotionValueEvent, useScroll, AnimatePresence } from "framer-motion";
import { ArrowRight, Menu, X } from "lucide-react";
import { ASSETS } from "@/lib/assets";
import { EASE } from "./motion";

const LINKS = [
  { id: "como-funciona", label: "Como funciona" },
  { id: "demo", label: "Demo" },
  { id: "recursos", label: "Recursos" },
  { id: "para-quem", label: "Para quem é" },
  { id: "planos", label: "Planos" },
  { id: "faq", label: "FAQ" },
];

export const Nav = () => {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);
  const { scrollY } = useScroll();
  useMotionValueEvent(scrollY, "change", (v) => setSolid(v > 40));

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50 px-4 sm:px-6 pt-4"
    >
      <div className={`mx-auto max-w-7xl rounded-2xl px-4 sm:px-5 h-16 flex items-center justify-between transition-all duration-500 ${solid ? "glass shadow-[0_10px_40px_-15px_rgba(15,23,42,0.15)]" : ""}`}>
        <a href="#top" data-testid="nav-logo" className="flex items-center">
          <img src={ASSETS.logo} alt="Lowpages" className="h-7 w-auto" />
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.id} href={`#${l.id}`} data-testid={`nav-link-${l.id}`} className="text-sm font-medium text-slate-600 hover:text-[var(--blue)] transition-colors">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href="/register" data-testid="nav-cta-button" className="btn btn-primary !py-3 !px-5 text-sm hidden sm:inline-flex">
            Começar grátis <ArrowRight size={16} className="arrow" />
          </a>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="lg:hidden h-10 w-10 rounded-full glass grid place-items-center" aria-label="Menu">
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-mobile-menu"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="lg:hidden mx-auto max-w-7xl mt-2 glass rounded-2xl p-4 flex flex-col gap-1 shadow-xl"
          >
            {LINKS.map((l) => (
              <a key={l.id} href={`#${l.id}`} onClick={() => setOpen(false)} data-testid={`nav-mobile-link-${l.id}`} className="px-3 py-3 rounded-xl font-medium text-slate-700 hover:bg-white hover:text-[var(--blue)]">
                {l.label}
              </a>
            ))}
            <a href="/register" data-testid="nav-mobile-cta" className="btn btn-primary mt-2 justify-center">Começar grátis</a>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
